import * as types from '../../../configs/constants/actionType'
import { takeLatest } from 'redux-saga/effects'
import { logoutSaga } from './logoutSaga'

const logout = [takeLatest(types.LOGOUT, logoutSaga)]

export default logout
